import { render, staticRenderFns } from "./Parameter.vue?vue&type=template&id=2822358f&scoped=true&"
import script from "./Parameter.vue?vue&type=script&lang=js&"
export * from "./Parameter.vue?vue&type=script&lang=js&"
import style0 from "./Parameter.vue?vue&type=style&index=0&id=2822358f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2822358f",
  null
  
)

export default component.exports